module.exports = __webpack_public_path__ + "4e2b6cb1362029c892b3afcd694f66c9.jpg";